import { Controller } from "@hotwired/stimulus"
import Chart from 'chart.js/auto'

// Small half-doughnut gauge showing a single dominant-segment percentage.
// The percentage/label are computed server-side (the dominant entry in
// mission_task.response_distribution, which is already sorted biggest-to-
// smallest) and passed straight in -- this controller only draws the arc.
// Mirrors chart_preview_controller.js's renderGaugeChart (circumference 180,
// rotation -90, cutout 70%) at small-card scale (card #3613 round 9).
//
// Example:
//   <canvas data-controller="gauge-chart"
//           data-gauge-chart-percentage-value="62"
//           data-gauge-chart-primary-color-value="#003d68">
//   </canvas>
export default class extends Controller {
  static values = {
    percentage:     { type: Number, default: 0 },
    primaryColor:   { type: String, default: "#003d68" },
    secondaryColor: { type: String, default: "#e5e7eb" }
  }

  connect() {
    this.initializeChart()
  }

  // Card #4273: without this, a Turbo Stream re-render can leave the stale
  // <canvas> in place while this controller reconnects, stacking a second
  // Chart.js instance on top of the first (same defect fixed in
  // doughnut_chart_controller.js and bar_chart_controller.js).
  disconnect() {
    this.destroyChart()
  }

  destroyChart() {
    this.chart?.destroy()
    this.chart = null
  }

  initializeChart() {
    this.destroyChart()

    const ctx = this.element.getContext('2d')
    const pct = Math.min(Math.max(this.percentageValue, 0), 100)

    this.chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        datasets: [{
          data: [pct, 100 - pct],
          backgroundColor: [this.primaryColorValue, this.secondaryColorValue],
          borderWidth: 0
        }]
      },
      options: {
        circumference: 180,
        rotation: -90,
        cutout: '70%',
        responsive: false,
        maintainAspectRatio: true,
        plugins: {
          legend: { display: false },
          tooltip: { enabled: false }
        }
      }
    })
  }
}
